import { render, staticRenderFns } from "./MonthlyReportManagement.vue?vue&type=template&id=2fac3d57&scoped=true"
import script from "./MonthlyReportManagement.vue?vue&type=script&lang=js"
export * from "./MonthlyReportManagement.vue?vue&type=script&lang=js"
import style0 from "./MonthlyReportManagement.vue?vue&type=style&index=0&id=2fac3d57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac3d57",
  null
  
)

export default component.exports